/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileWithRelations } from '../../models/file-with-relations';

export interface AdminGetDocuments$Params {
  itemId?: string;
  inventoryId: string;
}

export function adminGetDocuments(http: HttpClient, rootUrl: string, params: AdminGetDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetDocuments.PATH, 'get');
  if (params) {
    rb.query('itemId', params.itemId, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileWithRelations>>;
    })
  );
}

adminGetDocuments.PATH = '/admin/items/documents';
